<template>
  <VModal ref="modal" @modal:hidden="$emit('close')" :disable-backdrop-click="loading">
    <div class="mx-auto w-full max-w-xl">
      <BaseCard>
        <BaseCardHeader> Email Addresses </BaseCardHeader>
        <BaseCardBody>
          <div class="divide-y divide-gray-200 -my-4">
            <EmailAddressLine
              v-for="emailAddress in emailAddresses"
              :key="emailAddress.id"
              :contact-id="contactId"
              :email-address="emailAddress"
              :primary="primaryEmailAddress && emailAddress.id === primaryEmailAddress.id"
              :on-change="onRefreshContact"
            />
            <NewEmailAddressLine :contact-id="contactId" :on-created="onRefreshContact" />
          </div>
        </BaseCardBody>
      </BaseCard>
    </div>
  </VModal>
</template>

<script>
import EmailAddressLine from './EmailAddressLine.vue';
import NewEmailAddressLine from './NewEmailAddressLine.vue';

export default {
  components: {
    EmailAddressLine,
    NewEmailAddressLine,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
    primaryEmailAddress: {
      type: Object,
      default: () => null,
    },
    emailAddresses: {
      type: Array,
      default: () => [],
    },
    onRefreshContact: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
    };
  },
};
</script>
